import React from "react"
import { observer } from "mobx-react-lite"
import { Button, IconButton } from "@mui/material"
import { AlertModal } from "../../.."
import ClientList from "./ClientList"
import ClientDetails from "./ClientDetails"
import { Icons } from "../../../misc/Icons"
import { store } from "../../../stores/Store"
import PanelBody from "../../layout/PanelBody"
import PanelHeader from "../../layout/PanelHeader"
import { CustomerAccountCreateForm, SponsorCreateForm } from "../../form/admin/AccountForms"


export default observer(function ClientTool() {

    const {client, getClient, setClient, setTool} = store.ToolStore
    const {accounts, getAccounts} = store.NodeStore
    const [loading, setLoading] = React.useState(!!accounts)
    const title = store.AppStore.checkJwtRole("sysuser") ? "Customers & Sponsors" : "Sponsors"


    React.useEffect(() => {
        if (!accounts) {
            getAccounts().then(() => {
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }, [])


    return (
        <div className="panel panel-dark">
            <PanelHeader>
                {client ? (
                    <div style={{display: "flex", gap: "10px", flexFlow: "wrap", alignItems: "center"}}>
                        <h2>{client.label}</h2>

                        <Button
                            className="btn-sm"
                            color="success"
                            variant="contained"
                            onClick={() => setClient(null)}>
                            <Icons.DoubleArrow style={{transform: "rotateZ(180deg)"}} /> Back to {title} list
                        </Button>
                    </div>
                ) : (
                    <div style={{display: "flex", gap: "10px", flexFlow: "wrap", alignItems: "center"}}>
                        <h2>{title}</h2>

                        <div className="button-group">
                            <Button
                                color="success"
                                className="btn btn-sm"
                                variant="contained"
                                onClick={(e) => AlertModal({body: (
                                    <SponsorCreateForm parentUid={store.AppStore.sessionInfo.userAccount.uid} onSuccess={() => {
                                        store.NodeStore.getAccounts()
                                        store.AlertStore.Close()
                                    }} />
                                )})}>
                                Create Sponsor
                            </Button>
            
                            {store.AppStore.checkJwtRole("sysuser") ? (
                                <Button
                                    color="success"
                                    className="btn btn-sm"
                                    variant="contained"
                                    onClick={(e) => AlertModal({body: (
                                        <CustomerAccountCreateForm onSuccess={() => {
                                            store.NodeStore.getAccounts()
                                            store.AlertStore.Close()
                                        }} />
                                    )})}>
                                    Create Customer
                                </Button>
                            ) : null}
                        </div>
                    </div>
                )}

                <IconButton color="info" style={{margin: "0 0 auto auto"}} size="small" onClick={() => store.ToolStore.setTool(null)}><Icons.X /></IconButton>
            </PanelHeader>

            <PanelBody>
                <div className={loading ? "disabled" : ""} style={{display: "grid", gap: "20px", overflowY: "scroll", padding: "0 20px 20px 0"}}>
                    {client ? (
                        <ClientDetails />
                    ) : (
                        <ClientList handleSelect={async (uid) => {
                            setLoading(true)
                            await getClient(uid)
                            setLoading(false)
                        }} />
                    )}
                </div>
            </PanelBody>
        </div>
    )
})

